import React from "react";
import { Avatar as MuiAvatar, Tooltip } from "@mui/material";

interface AvatarProps {
  src: string;
  alt: string;
  size?: number;
  title?: string;
}

const Avatar: React.FC<AvatarProps> = ({ src, alt, size = 150, title }) => {
  return (
    <Tooltip title={title || alt} arrow>
      <MuiAvatar
        src={src}
        alt={alt}
        sx={{
          width: size,
          height: size,
          border: "3px solid #fff",
          boxShadow: "0 0 10px rgba(0,0,0,0.2)",
        }}
      />
    </Tooltip>
  );
};

export default Avatar;
